import { Button, Box } from "@mui/material";
import "./Addmember.css";

const FormFooter = ({ formik, handleFormSubmit, isPageLoading }) => {
  return (
    <Box sx={{ mt: 4, mb: 3, display: "flex", gap: 2 }}>
      <Button
        type="button"
        variant="contained"
        color="primary"
        onClick={(e) => handleFormSubmit(e, "submitOnly")}
        disabled={isPageLoading}
        size="large"
        sx={{ minWidth: 200 }}
      >SAVE & SUBMIT</Button>

      {/* <Button
        type="button"
        variant="contained"
        color="primary"
        onClick={(e) => handleFormSubmit(e, "submitAndMove")}
        disabled={isPageLoading}
        size="large"
        sx={{ minWidth: 200 }}
      >SAVE & CONTINUE TO CBAC</Button> */}
    </Box>
  );
};

export default FormFooter;
